export enum HealthClaimApprovalSortableFieldEnum {
  APPROVAL = 'approval',
  SYSTEM_APPROVAL = 'systemApproval',
}

export const ACTIVE_HEALTH_CLAIM_APPROVAL = {
  [HealthClaimApprovalSortableFieldEnum.APPROVAL]: 'ผู้อนุมัติ',
  [HealthClaimApprovalSortableFieldEnum.SYSTEM_APPROVAL]: 'ระดับอนุมัติ',

}
